import { LEGACY_HOME_PATH, type SessionResponse } from '@headline/schemas'
import { redirect } from '@tanstack/react-router'

/**
 * A person whose app is legacy leaves Headline's pages for it. A full navigation: `/legacy/` is a
 * different app behind the same hostname, which the router cannot reach. Called first in a page's
 * loader, because `user` is null for the normal legacy person, who holds no membership.
 *
 * `app` is only there where the deploy has `LEGACY_APP=on`; without it this does nothing.
 */
export function leaveForLegacy(session: Pick<SessionResponse, 'app'>): void {
  if (session.app === 'legacy') {
    throw redirect({ href: LEGACY_HOME_PATH, reloadDocument: true })
  }
}
